import useCustomHook from '@/hooks/useCustomHook';
import { useEffect } from 'react';

export default function useTrainingActivity({
  activity,
  initialTaskProgress,
  taskProgressAPI,
  onFinishedActivity,
}) {
  const questions = activity?.data?.questions;

  const { state, actions } = useCustomHook({
    defaultState: {
      activityConf: null,
      questionIdsListened: [],
      finished: false,
      questionPlaying: null,
    },
    actions: {
      onQuestionPlaying: (question) => {
        actions.setState({
          questionPlaying: question,
        });
      },
      onQuestionListened: async (question) => {
        const questionIdsListened = [...state.questionIdsListened];
        if (!questionIdsListened.includes(question.id)) {
          questionIdsListened.push(question.id);
        }

        actions.setState({
          questionIdsListened,
          questionPlaying: null,
        });

        const progress = Math.ceil(
          (questionIdsListened.length * 100) / questions.length
        );

        const gamificationProgressData = {
          progress,
          correctAnswers: [],
        };

        await taskProgressAPI.PROGRESS(
          {
            progress,
            questionIdsListened,
          },
          gamificationProgressData
        );

        if (
          questionIdsListened.length == questions.length &&
          questionIdsListened.length > 0
        ) {
          actions.showFinishScreen();
        }
      },
      showFinishScreen: async () => {
        onFinishedActivity();
        actions.setState({
          currentScreen: null,
          finished: true,
        });
      },
    },
  });

  useEffect(() => {
    if (initialTaskProgress?.questionIdsListened) {
      actions.setState({
        questionIdsListened: initialTaskProgress.questionIdsListened,
      });
    }
  }, [initialTaskProgress]);

  return {
    state,
    actions,
  };
}
